import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {useMemo} from 'react';

import {BackendResponse} from '@common/http/backend-response/backend-response';
import {RequestTitle} from '@app/titles/models/Request';

export interface GetRequestResponse extends BackendResponse {
  request: RequestTitle;
  updated_at: string; // Assurez-vous que updated_at est inclus
}

const requestCache = new Map<number, GetRequestResponse>();

export function useRequest(requestId: number | undefined) {
  const cachedRequest = requestId ? requestCache.get(requestId) : null;
  const updatedAt = cachedRequest?.updated_at;

  const memoizedRequest = useMemo(() => {
    if (requestId && cachedRequest) {
      return cachedRequest;
    }
    return null;
  }, [requestId, updatedAt]); // Utilisez updatedAt comme dépendance

  return useQuery({
    queryKey: ['requests', `${requestId}`],
    queryFn: () => {
      if (memoizedRequest) {
        return Promise.resolve(memoizedRequest);
      }
      return fetchLien(requestId!).then(response => {
        if (requestId) {
          requestCache.set(requestId, response);
        }
        return response;
      });
    },
  });
}

function fetchLien(requestId: number | undefined) {
  if (!requestId) {
    return Promise.reject('Request ID is required');
  }
  return apiClient
    .get<GetRequestResponse>(`requests/${requestId}`)
    .then(response => response.data);
}
